import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type JiraIssuesQueryVariables = Types.Exact<{
  filters?: Types.InputMaybe<Types.JiraIssueFilters>;
  first?: Types.InputMaybe<Types.Scalars['Float']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  sort?: Types.InputMaybe<Array<Types.SortType> | Types.SortType>;
  entityFilter?: Types.InputMaybe<Types.ActionItemEntityFilter>;
  fileFilter?: Types.InputMaybe<Types.FileFilters>;
}>;


export type JiraIssuesQuery = { jiraIssues: { totalCount: number, pageInfo?: { hasNextPage?: boolean | null, endCursor?: string | null } | null, edges?: Array<{ node: { id?: string | null, dueDate?: string | null, project?: string | null, summary?: string | null, status?: string | null, statusId?: string | null, key?: string | null, isActionItemLinked: boolean, statusCategory?: { id: string, name: string, key: Types.JiraStatusCategoryKeyEnum } | null, assigneeInfo?: { emailAddress?: string | null, displayName?: string | null, user?: { emailId?: string | null, profilePicture?: string | null, id: string } | null } | null, priorityInfo?: { id: string, name: string } | null } }> | null } };


export const JiraIssuesDocument = /*#__PURE__*/ gql`
    query jiraIssues($filters: JiraIssueFilters, $first: Float, $after: String, $sort: [SortType!], $entityFilter: ActionItemEntityFilter, $fileFilter: FileFilters) {
  jiraIssues(sort: $sort, filters: $filters, first: $first, after: $after) {
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        id
        dueDate
        project
        summary
        status
        statusId
        statusCategory {
          id
          name
          key
        }
        key
        assigneeInfo {
          emailAddress
          displayName
          user {
            emailId
            profilePicture
            id
          }
        }
        priorityInfo {
          id
          name
        }
        isActionItemLinked(entityFilter: $entityFilter, fileFilter: $fileFilter)
      }
    }
  }
}
    `;

export function useJiraIssuesQuery(options?: Omit<Urql.UseQueryArgs<JiraIssuesQueryVariables>, 'query'>) {
  return Urql.useQuery<JiraIssuesQuery, JiraIssuesQueryVariables>({ query: JiraIssuesDocument, ...options });
};